export default "__VITE_ASSET__BZ_MiHS6__"